export enum JoiningType {
  Experienced,
  Training,
  Recommendation,
}

export enum EligibilitySteps {
  JoiningAs,
  AdditionalInformation,
}

export interface IEligibilityFormModel {
  [EligibilitySteps.JoiningAs]: IJoiningAsFormModel;
  [EligibilitySteps.AdditionalInformation]: IAdditionalInformationFormModel;
}

export interface IJoiningAsFormModel {
  joiningAs: JoiningType | null;
}

export interface IAdditionalInformationFormModel {
  [JoiningType.Experienced]: ICreditFormModel[];
  [JoiningType.Training]: ICourseFormModel[];
  [JoiningType.Recommendation]: IRecommendationFormModel;
}

export interface ICreditFormModel {
  productionName: string;
  type: number | null;
  roleName: string;
  company: string;
  director: string;
  creditLink: string;
  dateFrom: Date | null;
  dateTo: Date | null;
  s3ObjectKey: string;
  equityRole: "yes" | "no" | null;
}

export interface ICourseFormModel {
  schoolName: string;
  courseName: string;
  dateFrom: Date | null;
  dateTo: Date | null;
  qualificationLevel: number | null;
  courseUrl: string;
  s3ObjectKey: string;
  courseType: "yes" | "no" | null;
}

export interface IRecommendationFormModel {
  refereeName: string;
  refereeMembership: string | null;
  s3ObjectKey: string;
}
